import { fetcher } from './apiClient';

export type DevicePing = {
    id: string;
    deviceId: string;
    currentSport: string | null;
    imageRoute: string | null;
    isSport: boolean;
    isCommercial: boolean;
    createdAt: string;
};

export const devicePingsFetcher = (url: string): Promise<DevicePing[]> =>
    fetcher<DevicePing[]>(url);
